<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-container-single element-non-bodymatter element-type-epigraph element-without-heading" id="epigraph">
<div class="text" id="epigraph-text">
<div class="blockquote-container prose with-attribution">
<blockquote class="prose with-attribution">
<div class="paragraph-and-attribution">
<p class="first blockquote-content blockquote-content-prose blockquote-position-first">How blessed is the man whose strength is in the Lord…he will go from strength to strength.</p>
<p class="blockquote-attribution blockquote-position-last">Psalm 84:5-7</p>
</div>
</blockquote>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?13e4ec00